import { formatTimeDuration } from '@racemap/utilities/formattings/times';
import { formatDistance } from '@racemap/utilities/formattings/units';
import {
  type Geofence,
  type PreparedRanksPackage,
  type PreparedStarterInfo,
  sortTimes,
  testEventHasVirtDuration,
} from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Unit } from '@racemap/utilities/types/units';
import type { Immutable } from 'immer';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';
import { LARGE_TIME_COL_WIDTH, SMALL_TIME_COL_WIDTH } from './TimesCol';

function DifferenceColComponent({
  starterInfo,
  event,
  timekeepings,
  eventData,
}: {
  starterInfo: Immutable<PreparedStarterInfo>;
  event: Immutable<RacemapEvent>;
  timekeepings: Immutable<Array<Geofence>>;
  eventData: Immutable<PreparedRanksPackage>;
}) {
  const eventHasVirtDuration = testEventHasVirtDuration(event);
  const unitType = event.playerOptions.unitType;
  const starterResult = starterInfo?.results[timekeepings.length - 1];
  const leaderResult = eventData?.starters[0]?.results[timekeepings.length - 1];
  const withoutStart = starterInfo?.results[0] == null;
  const noRank = starterInfo?.rank === -1;

  return (
    <Cell>
      <div>
        {starterResult != null &&
        leaderResult != null &&
        starterResult !== leaderResult &&
        !withoutStart &&
        !noRank
          ? eventHasVirtDuration
            ? `+${formatDistance({
                value: leaderResult?.relativeProgress - starterResult?.relativeProgress,
                inputUnit: Unit.Distance.m,
                unitType,
              })}`
            : `+${formatTimeDuration(
                starterResult?.relativeProgress - leaderResult?.relativeProgress,
              )}`
          : '-'}
      </div>
    </Cell>
  );
}

export function getDifferenceCol(
  event: Immutable<RacemapEvent>,
  timekeepings: Immutable<Array<Geofence>>,
  windowWidth: number,
  eventData: Immutable<PreparedRanksPackage>,
): Column {
  const eventHasVirtDuration = testEventHasVirtDuration(event);

  return {
    key: 'difference',
    title: 'Difference',
    width:
      windowWidth < 990 || timekeepings.length > 6 ? SMALL_TIME_COL_WIDTH : LARGE_TIME_COL_WIDTH,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return (
        <DifferenceColComponent
          event={event}
          timekeepings={timekeepings}
          starterInfo={row}
          eventData={eventData}
        />
      );
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) =>
      eventHasVirtDuration
        ? b?.results[timekeepings?.length - 1]?.relativeProgress -
          a?.results[timekeepings?.length - 1]?.relativeProgress
        : sortTimes(
            b?.results[timekeepings?.length - 1]?.relativeProgress,
            a?.results[timekeepings?.length - 1]?.relativeProgress,
          ),
  };
}
